export default {
  title: 'Connect {asset} to data source',
};
